






class Line
  constructor: (@ctx, @bg, indexX, indexY) ->
    @active = false
    @points = []
    cx = @bg.dist.x
    cy = @bg.dist.y
    max = Math.max(@bg.linesCount.x + 1, @bg.linesCount.y + 1)
    while indexX <= @bg.linesCount.x + 1 and indexY <= @bg.linesCount.y + 1
      x = indexX * cx
      y = indexY * cy
      hue = ( (indexX + indexY) / max / 2 ) * 360
      color = "hsla(#{ Math.round hue }, 30%, 50%, 1)"
      @points.push { x, y, color }
      indexX++
      indexY++

  draw: (alpha, rad) ->
    start = true
    alpha += 60 * @startPoint
    for { x, y, color }, index in @points when @startPoint <= index <= @startPoint + @length
      if start
        @ctx.beginPath()
        x += @bg.dist.x * @nextPointAfter
        y += @bg.dist.y * @nextPointAfter
        @ctx.moveTo(Math.round(x) - 1, Math.round(y) - 1)
        start = false
      else
        offset = Math.sin(alpha * rad)
        @ctx.lineTo(x - offset, y + offset)
        @ctx.strokeStyle = color
        @ctx.lineWidth = 0.1
        @ctx.stroke()
      alpha += 60

    @nextPointAfter += @speed
    if @nextPointAfter > 1
      @nextPointAfter -= 1
      if ++@startPoint >= @points.length
        @active = false
    null


export default
  data: ->
    ctx: null
    lines: []
    animRequest: null
    width: @$dimensions.width
    height: @$dimensions.height
    timeout: null

  watch:
    '$dimensions.height': ->
      { @width, @height } = @$dimensions

  computed:
    linesCount: ->
      x: Math.ceil @width * 0.015
      y: Math.ceil @height * 0.015

    dist: ->
      x: @width / (@linesCount.x + 1)
      y: @height / (@linesCount.y + 1)

  mounted: ->
    @ctx = @$el.getContext('2d')
    @lines.push(new Line @ctx, this, 0, y) for y in [0...@linesCount.y]
    @lines.push(new Line @ctx, this, x, 0) for x in [1...@linesCount.x]
    requestAnimationFrame(@update)
    @spawnLine()

  beforeDestroy: ->
    cancelAnimationFrame(@animRequest)
    clearTimeout @timeout

  methods:
    update: ->
      @animRequest = requestAnimationFrame(@update)

      @ctx.clearRect(0, 0, @width, @height)
      @ctx.lineWidth = 0.05

      alpha = (Date.now() % 60000) / 4
      rad = Math.PI / 180

      for line in @lines when line.active
        line.draw(alpha, rad)
      null

    spawnLine: ->
      line = @lines.pickRandom()
      if not line.active
        line.active = true
        line.length = Math.randomIntBetween(2, 4)
        line.speed = (0.5 + Math.fastRandom()) / 35
        line.startPoint = 0
        line.nextPointAfter = 0
      @timeout = setTimeout @spawnLine.bind(this), 300 + Math.random() * 600

